
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.96 17.626h1.898v1.764c0 2.112 1.077 3.178 3.22 3.178h10.95c2.144 0 3.22-1.066 3.22-3.178V8.49c0-2.102-1.076-3.169-3.22-3.169h-1.896v-1.66c0-2.113-1.087-3.18-3.22-3.18H3.961C1.808.481.74 1.548.74 3.661v10.796c0 2.113 1.067 3.169 3.22 3.169zm.021-1.65c-1.025 0-1.589-.544-1.589-1.61V3.751c0-1.066.564-1.62 1.59-1.62h10.9c1.014 0 1.599.554 1.599 1.62v1.57H9.078c-2.143 0-3.22 1.055-3.22 3.168v7.485H3.98zm5.127 4.941c-1.025 0-1.6-.553-1.6-1.62V8.582c0-1.066.575-1.61 1.6-1.61h10.9c1.015 0 1.59.544 1.59 1.61v10.726c0 1.056-.575 1.61-1.59 1.61h-10.9z","fill":"#2E7CF6"}})])
          )
        }
      }
    